import { monthKeyFromT } from './engine/calendar'
import type { HistoryMonths } from '@/store/projectionsStore'

export function getVisibleTimeIndices(
  nHistory: number,
  historyMonths: HistoryMonths,
): { histTs: number[]; projTs: number[] } {
  const count = historyMonths === 'all' ? nHistory : historyMonths
  const visible = Math.min(count, nHistory)
  const startT = -(visible - 1)
  const histTs: number[] = []
  for (let t = startT; t <= 0; t += 1) {
    histTs.push(t)
  }
  const projTs = Array.from({ length: 36 }, (_, i) => i + 1)
  return { histTs, projTs }
}

export function monthLabel(lastClosedMonth: string, t: number): string {
  return monthKeyFromT(lastClosedMonth, t)
}

export function monthOffsetLabel(t: number): string {
  if (t < 0) return `M${t}`
  return `M+${t}`
}

export function lastHistMonthLabel(lastClosedMonth: string): string {
  return monthKeyFromT(lastClosedMonth, 0)
}
